<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">Configurações de Contas a Receber</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Configure as configurações de contas a receber.
        </p>
      </div>
    </div>

    @if (isLoading) {
      <div class="row mb-3">
        <div class="col-12 col-md-4">
          <app-loading-box height="56" width="100%"></app-loading-box>
        </div>
        <div class="col-12 col-md-4">
          <app-loading-box height="56" width="100%"></app-loading-box>
        </div>
      </div>
      <div class="section-container">
        <app-loading-box height="30" width="280" marginTop="0"></app-loading-box>
        <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
        <app-loading-box height="20" width="200" marginTop="16"></app-loading-box>
        <app-loading-box height="200" width="100%" marginTop="8"></app-loading-box>
      </div>
    } @else {
      <form [formGroup]="form">
        <div class="config-fields mb-3">
          <div class="config-field config-field-aviso">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Avisar cliente por e-mail</mat-label>
              <mat-select formControlName="idTipoAvisoVencimento">
                @for (opcao of opcoesTipoAviso; track opcao.idTipoAvisoVencimento) {
                  <mat-option [value]="opcao.idTipoAvisoVencimento">{{ opcao.descricao }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="config-field config-field-boleto">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Emissão automática de boletos ao salvar contas a receber</mat-label>
              <mat-select formControlName="isBoletoAutomatico">
                <mat-option [value]="false">Manual</mat-option>
                <mat-option [value]="true">Automático ao salvar contas a receber</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        @if (form.get('idTipoAvisoVencimento')?.value > tipoAvisoVencimentoEnum.NaoAvisar) {
          <div class="section-container" id="aviso-email">
            <div class="section-title">
              <mat-icon>email</mat-icon>
              <span>Template de Notificação por E-mail</span>
              <mat-icon
                class="info-icon"
                matTooltip="Todos os e-mails cadastrados no contato do cliente receberão esta notificação automaticamente."
                matTooltipPosition="above"
                >info_outline</mat-icon
              >
            </div>
            <div class="row">
              <div class="col-12 mt-3">
                <mat-form-field appearance="outline" class="w-100 mt-2">
                  <mat-label>Assunto do e-mail</mat-label>
                  <input matInput #assuntoInput formControlName="assuntoEmail" />
                  @if (form.get('assuntoEmail')?.hasError('required')) {
                    <mat-error>O assunto é obrigatório.</mat-error>
                  }
                </mat-form-field>

                <label class="mb-2">Mensagem (Corpo do e-mail):</label>
                <div class="editor-container">
                  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                  <ngx-editor
                    [editor]="editor"
                    formControlName="corpoEmailHtml"
                    placeholder="Escreva a mensagem...">
                  </ngx-editor>
                  @if (
                    form.get('corpoEmailHtml')?.hasError('required') && form.get('corpoEmailHtml')?.touched
                  ) {
                    <mat-error>A mensagem é obrigatória.</mat-error>
                  }
                </div>

                <a class="variaveis-link" (click)="toggleVariaveisEmail()" id="toggle-variaveis-email">
                  <mat-icon class="variaveis-icon">swap_horiz</mat-icon>
                  {{ showVariaveisEmail ? 'Ocultar variáveis disponíveis' : 'Exibir variáveis disponíveis' }}
                </a>

                @if (showVariaveisEmail) {
                  <app-alert-card type="info">
                    <strong>Variáveis disponíveis para uso na mensagem:</strong>
                    <ul class="variaveis-list mt-2 mb-0">
                      @for (variavel of variaveisEmail; track variavel.codigo) {
                        <li>
                          <button
                            mat-button
                            type="button"
                            class="variavel-button"
                            (click)="inserirVariavelEmail(variavel.codigo)">
                            <code>{{ variavel.codigo }}</code>
                          </button>
                          <span>{{ variavel.descricao }}</span>
                        </li>
                      }
                    </ul>
                  </app-alert-card>
                }
              </div>
            </div>
          </div>
        }
      </form>
    }
  </div>
</div>

<app-footer-action
  [isLoadingSalvar]="isSaving"
  [isSalvarDisabled]="isLoading"
  (cancelar)="voltar()"
  (salvar)="salvar()">
</app-footer-action>
